// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QAEu","newExpiryDate":"styles_newExpiryDate__1bHk4","footer":"styles_footer__3FBjK"};